import { API } from 'aws-amplify';
import { authHeader } from 'utils/auth';

export async function getHRISEmployeesBlobData(reportId: string): Promise<Blob | null> {
  const apiName = 'hrisDataAPI';
  const path = `/report/${reportId}/hris-data/employees`;
  const headers = await authHeader();
  try {
    return await API.get(apiName, path, {
      responseType: 'blob',
      headers
    });
  } catch (error) {
    console.log('Error: ', error);
    return null;
  }
}
